
const vDonate = Vue.createApp(jdw.components.Donate)

vDonate.mount('#v-donate')
jdw.apps.vDonate = vDonate
